import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { Subject } from 'rxjs';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDtoEmployeeContract } from 'app/shared/models/recruitment/dto-employee-contract.model';
import { IAngularMyDpOptions } from 'angular-mydatepicker';
import { IDtoJobCandidate } from 'app/shared/models/recruitment/dto-job-candidate.model';
import { IResult } from 'app/shared/models/result.model';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import { AdministrationService } from 'app/views/appviews/quote/administration.service';
import { WorkLeaveService } from 'app/views/appviews/request/workLeave.service';
import { PayrollService } from 'app/views/appviews/payroll.service';
@Component({
  selector: 'app-modal-hire-employee',
  templateUrl: './modal-hire-employee.template.html',
  encapsulation: ViewEncapsulation.None
})

export class ModalHireEmployeeComponet implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [true];
  private errorMessages: any;
  /**Catalogos */
  //private catalogEmployees: Observable<ISelect[]>;
  private action: string;
  /**Formularios */
  private formHireEmployee: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<IResult>;
  private locale: string = 'es';
  private jobCandidate: IDtoJobCandidate;
  /**Fechas */
  private pickerOptionsContract: IAngularMyDpOptions;
  private missing: boolean;
  private openPeriod: boolean;
  private positionType: string;
  private hasInfonavit: boolean;
  private currentDate: Date;
  private openCalendar: boolean;
  private inductionMessage = '';
  constructor(private bsModalRef: BsModalRef
    , private recruitmentService: RecruitmentService
    , private formBuilder: FormBuilder
    , private spinner: NgxSpinnerService
    , private configGeneral: AppConfig
    , private administrationService: AdministrationService
    , private workLeaveService: WorkLeaveService
    , private payrollService: PayrollService) {
    this.initializeFormHireEmployee();
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.getCandidatePositionType();
    this.getOpenCalendar();
    this.getCurrentDate();
  }

  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private initializeFormHireEmployee() {
    this.formHireEmployee = this.formBuilder.group({
      hiringDate: [null, [Validators.required]]
    });
  }
  private getOpenCalendar(): void {
    this.administrationService.getOpenCalendar('open_hiring_calendar').subscribe(res => {
      this.openCalendar = res;
    })
  }
  private getCurrentDate(): void {
    this.workLeaveService.getCurrentDate().subscribe(x => {
      let date = new Date(x);
      this.currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    });
  }
  submitForm(): void {
    if (this.formHireEmployee.valid) {
      if (!this.openCalendar) {
        if (this.formHireEmployee.value.hiringDate.singleDate.jsDate >= this.currentDate) {
          this.save();
        }
        else {
          this.configGeneral.newToast('Validación', 'Solo puede seleccionar una fecha igual o mayor a la actual', 'error');
        }
      } else {
        this.save();
      }

    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
    }
  }
  private getDocuments(): void {
    this.spinner.show();
    this.recruitmentService.getJobCandidateDocumentsByJobCandidateId(this.jobCandidate.id)
      .subscribe(
        (x) => {
          this.spinner.hide();
          this.recruitmentService.getCatalogDocumens().subscribe(d => {
            //regresar o comentar despues de la contratacion henkel
            // let doc = d.find(x => x.documentName == 'RFC');
            // if (this.positionType == 'E') {
            //   doc.required = false;
            // } else {
            //   doc.required = true;
            // }
            //

            let doc1 = d.find(x => x.documentName == 'AvisoRetencion');
            if (this.hasInfonavit == false) {
              doc1.required = false;
            } else {
              doc1.required = true;
            }
            let c = d.filter(i => i.required == true);
            this.recruitmentService.getCandidateInduction(this.jobCandidate.id, this.jobCandidate.positionId)
            .subscribe(
            (e) => {
              let induction = Boolean(e.data);
              this.missing = this.missingDocument(x, c, induction);
            });
          });
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private missingDocument(documents: IDocument[], catalog: IDocument[], induction: boolean): boolean {
        if (induction == false){
          this.inductionMessage = 'No cuenta con inducción';
          return true;
        }
        if (induction == true){
          for (let i = 0; i < catalog.length; i++) {
            let res = documents.filter(f => f.documentName == catalog[i].documentName);
            if (res.length == 0) {
              return true;
            }
          }
        }
  return false;
  }
  private save(): void {
    this.spinner.show();
    let data = Object.assign({}, this.formHireEmployee.value as IDtoEmployeeContract);
    data.hiringDate = this.configGeneral.getDate(this.formHireEmployee.value.hiringDate);
    data.jobCandidateId = this.jobCandidate.id;
    data.positionId = this.jobCandidate.positionId;
    this.payrollService.validatePayrollContractByEmployee(data.positionId, this.configGeneral.dateFormat(data.hiringDate, 'yyyy-mm-dd'), data.jobCandidateId)
        .subscribe((x) => {
      if (x.data.toString() == 'true') {
        this.spinner.hide();
        this.openPeriod = true;
        return;
      }
            this.recruitmentService.jobCandidatesContract(data)
            .subscribe(
                (x) => {
                  this.spinner.hide();
                  this.onClose.next(x);
                  this.onCancel();
                },
            (errMessage) => {
              this.spinner.hide();
              this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
        },
      (errMessage) => {
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
  }
  private restrictDateContract(date: Date) {
    this.pickerOptionsContract = {
      dateFormat: 'dd.mm.yyyy',
      dateRange: false,
      disableDateRanges: [{
        begin: { year: 1000, month: 1, day: 1 },
        end: { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate() - 1 }
      }]
    }
  }
  private getCandidatePositionType(): void {
    this.recruitmentService.getCandidatePositionType(this.jobCandidate.id)
      .subscribe(
        (x) => {
          this.positionType = x;
          console.log(this.jobCandidate);
          this.recruitmentService.getCandidateHasInfonavit(this.jobCandidate.id)
            .subscribe(
              (x) => {
                this.hasInfonavit = Boolean(x);
                this.getDocuments();
              },
              (errMessage) => {
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
              });
        },
        (errMessage) => {
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
}
